module.exports = __webpack_public_path__ + "img/ys3.dceebc64.png";